import Storage from "../protocol/Storage";
import { BACK_TO_BTN } from "./Constants";

export function setBackToSrchBtn(backToBtn: string) {
	Storage.set(BACK_TO_BTN.BACK_TO_SRCH, backToBtn);
}
export function getBackToSrchBtn() {
	return Storage.get(BACK_TO_BTN.BACK_TO_SRCH);
}